﻿import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { UserModel } from "../../../model/jubili/setting-user/user-data";
import { apiLink } from "../../../constant/api-link";
import { ImageResponse } from "../../../model/jubili/upload-image/ImageResponse";
import { ImageUploadModel } from "../../../model/jubili/upload-image/Image-upload-model";

@Injectable({
  providedIn: "root"
})
export class SettingService {

  constructor(
    private http: HttpClient
  ) {
  }

  // get all user backoffice
  getUserBackOffice(): Observable<UserModel> {
    const url = apiLink.getJuAdminList;

    return this.http.get<UserModel>(url);
  }

  // delete permission login
  deletePermissionBackOffice(userSurrkey: number): Observable<boolean> {
    const url = apiLink.updateJuAdminPermission;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.put<boolean>(url, userSurrkey, { headers });
  }

  uploadImage(image: any, companyId: number): Observable<ImageResponse> {
    const url = apiLink.uploadImageFile;

    const data = new FormData();
    data.append("image", image);
    data.append("companySurrkey", companyId.toString());
    let sub = this.http.post<ImageResponse>(url, data);
    return sub;
  }

  uploadImageListImport(models: Array<ImageUploadModel>, companyId: number, actionById: number): Observable<boolean> {
    const url = apiLink.uploadImageListImport;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const data = {
      "CompanyId": companyId,
      "ActionById": actionById,
      "UploadImageList": models
    }
    let sub = this.http.post<boolean>(url, data, { headers });

    return sub;
  }
}
